import { useTranslation } from "react-i18next"
import { Button, Checkbox, Popover, PopoverContent, PopoverTrigger } from "@nexus/ui"
import { MY_BRAND_HIDEABLE_COLUMNS } from "../lib/my-brand-list-columns"
import { useDrilldownFiltersStore } from "../stores/drilldownFilters.store"

/** Show or hide the My Brand list view's date columns. KPI columns stay on the pill row. */
export function MyBrandColumnsMenu() {
  const { t } = useTranslation()
  const hiddenColumns = useDrilldownFiltersStore((s) => s.myBrandHiddenColumns)
  const toggleMyBrandColumn = useDrilldownFiltersStore((s) => s.toggleMyBrandColumn)

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          data-testid="my-brand-columns-menu"
          aria-label={t("drilldown.myBrandColumns.menuAria", "Show or hide date columns")}
          className="shrink-0"
        >
          {t("drilldown.myBrandColumns.menu", "Columns")}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[180px] p-1">
        {MY_BRAND_HIDEABLE_COLUMNS.map((column) => {
          const label = t(column.i18nKey, column.defaultLabel)
          const isHidden = hiddenColumns.includes(column.key)
          return (
            <label
              key={column.key}
              className="flex min-h-11 cursor-pointer items-center gap-2 rounded-md px-2 text-sm text-foreground hover:bg-muted"
            >
              <Checkbox
                checked={!isHidden}
                aria-label={label}
                data-testid={`my-brand-column-toggle-${column.key}`}
                onCheckedChange={() => toggleMyBrandColumn(column.key)}
              />
              {label}
            </label>
          )
        })}
      </PopoverContent>
    </Popover>
  )
}
